var _path, _rect, _rect2, _rect3, _rect4, _circle, _circle2, _circle3, _circle4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgListados = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#fff",
    width: 20,
    height: 20,
    id: "ea3ba7fa-2217-4553-b9cf-18144e8d0d63",
    "data-name": "Capa 1",
    viewBox: "0 0 14.28 18.89",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.6,11.1a.3.3,0,0,0-.6,0c0,.75,0,1.84,0,2.59V17a6.92,6.92,0,0,0,0,1,1,1,0,0,0,1,.84,1.47,1.47,0,0,0,.21,0H12.55c.23,0,.46,0,.69,0a1,1,0,0,0,1-.7,3.69,3.69,0,0,0,0-1.05v-13c0-.21,0-.46-.11-.63L14,3.38,12.76,2.05,11.27.51C11.15.38,11,.24,10.89.12A.53.53,0,0,0,10.46,0H2.24c-.4,0-.8,0-1.19,0A1.1,1.1,0,0,0,.41.23C-.06.6,0,1.21,0,1.74V3.35C0,4.12,0,10.28,0,11a.3.3,0,0,0,.6,0c0-.65,0-6.71,0-7.36V1.22C.63,1,.62.78.84.66A.83.83,0,0,1,1.29.61h9.37L10.45.52l.41.43,2.9,3-.09-.21V17.65a.8.8,0,0,1-.07.46.43.43,0,0,1-.36.17H1.07A.41.41,0,0,1,.7,18.1a.53.53,0,0,1-.07-.37V17c0-1.85,0-4.06,0-5.92Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.35.49V3.32a.71.71,0,0,0,.72.71h2.66",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.7999999821186066px"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.04,
    y: 6.31,
    width: 8.75,
    height: 0.82
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.04,
    y: 9.06,
    width: 8.75,
    height: 0.82
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.04,
    y: 11.83,
    width: 8.75,
    height: 0.82
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4.04,
    y: 14.71,
    width: 8.75,
    height: 0.82
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.51,
    cy: 6.7,
    r: 1.01
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.51,
    cy: 9.47,
    r: 1.01
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.51,
    cy: 12.24,
    r: 1.01
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.51,
    cy: 15.12,
    r: 1.01
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgListados, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/listados.c7cc93cb.svg";
export { ForwardRef as ReactComponent };